import styled from "styled-components";

// ── Styled Components ────────────────────────────────────────────────────────

const TogglerContainer = styled.div`
  font-size: 1rem;
  font-weight: bold;
  background-color: #fff;
  padding: 24px;
  border-radius: 4px;
  display: flex;
  justify-content: space-around;
  cursor: pointer;
`;

const TogglerItem = styled.div`
  background-color: #fff;
  color: ${({ $active }) => ($active ? "#113281" : "#ababab")};
  flex: 1;
  text-align: center;
  border-bottom: ${({ $active }) => ($active ? "5px" : "2px")} solid #113281;
  padding: 12px;
  position: relative;
`;

const Notification = styled.div`
  background-color: red;
  position: absolute;
  right: 30%;
  top: 1px;
  width: 20px;
  height: 20px;
  border-radius: 100%;
  color: #d9dedf;
`;

// ── Component ────────────────────────────────────────────────────────────────

export default function Toggler({ values, onChange, currentValue, notify }) {
  return (
    <TogglerContainer>
      {values.map((value) => (
        <TogglerItem
          key={value}
          $active={currentValue === value}
          onClick={() => onChange(value)}
        >
          {value === "Executed Models" && notify && (
            <Notification>1</Notification>
          )}
          {value}
        </TogglerItem>
      ))}
    </TogglerContainer>
  );
}
